import React, { useState } from 'react';
import { useAppContext } from 'src/components/app-context';
import {
  Behavior,
  FontEmphasis,
  H4Text,
  TitleSmallText,
} from '@prisjakt/ui/text/variants';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';

import { RadioButton } from '@prisjakt/ui/radiobutton';
import { ModalBody } from '@prisjakt/ui/modal';
import Modal from 'src/components/modal-v2';
import FilterToggleButton from './filter-toggle-button';
import { AllFiltersLoader } from './all-filters';

import type { IOfferListFilters } from '../types';

import { FilterRow, MobileWrapper } from '../styles';

export const MainOfferlistFiltersMobile = (props: IOfferListFilters) => {
  const {
    applicableFilters,
    activeOfferlistFilters,
    onSort,
    currentSorting,
    sortOptions,
    className,
  } = props;
  const { t } = useAppContext();
  const { toggleFilter } = useOfferListFilterContext();
  const [showFilters, setShowFilters] = useState<boolean>(false);
  const closeHandler = () => setShowFilters(false);
  const toggleHandler = () => setShowFilters(!showFilters);

  const renderSortingRadios = () =>
    sortOptions?.map(option => (
      <div key={option.title}>
        <RadioButton
          onClickHandler={() => {
            onSort?.(option);
          }}
          text={option.title}
          value={option?.title || sortOptions[0].title}
          selectedValue={currentSorting?.title}
        />
      </div>
    ));

  const getSortFilter = () => {
    if (sortOptions?.length) {
      return (
        <>
          <H4Text>{t('common', 'sort.title')}</H4Text>
          {renderSortingRadios()}
        </>
      );
    }
    return (
      <TitleSmallText
        flex={false}
        emphasis={FontEmphasis.LOW}
        behavior={Behavior.Oneline}
      >
        {t('product', 'sorting.sorted-by-cheapest-price')}
      </TitleSmallText>
    );
  };

  return (
    <div className={className}>
      <FilterToggleButton
        toggleHandler={toggleHandler}
        activeFilters={activeOfferlistFilters.length}
      />

      {showFilters && (
        <Modal isOpen={showFilters} onRequestClose={closeHandler}>
          <ModalBody>
            <MobileWrapper>
              {Boolean(sortOptions?.length) && (
                <div>
                  <FilterRow>{getSortFilter()}</FilterRow>
                </div>
              )}
              <AllFiltersLoader
                filters={applicableFilters}
                onToggleFilter={toggleFilter}
              />
            </MobileWrapper>
          </ModalBody>
        </Modal>
      )}
    </div>
  );
};
